import React, { PureComponent } from 'react';
import TripDetailsCard from './components/tripdetailscard';
import Spinner from '../shared/spinner';
import { calculateDueDate  } from '../../helpers/utils';
import Footer from '../shared/footer';
import { calculateAccommodationPrice } from '../../helpers/priceHelper';
import _filter from 'lodash/filter';
import _map from 'lodash/map';
import _sortBy from 'lodash/sortBy';
import { CYOA_NETWORK_IDS } from '../../config';

class ConfirmationPaymentCyoa extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      grandTotalPrice:0,
      grandTotal:0,
      subtotal:0,
      discount:0,
      accommodation:0
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { bookingGroup, itineraries } = this.props;


    if(bookingGroup !== prevProps.bookingGroup) this.populatePaymentDetails(bookingGroup, itineraries);

    //CYO tours
    if(itineraries !== prevProps.itineraries) this.populatePaymentDetails(bookingGroup, itineraries);

  }

  componentDidMount(){
    const { bookingGroup, itineraries } = this.props;

    if(bookingGroup.bookings !== undefined){
      this.populatePaymentDetails(bookingGroup, itineraries);
    }

  }

  populatePaymentDetails(bookingGroup, itineraries){


    const HAS_CYO = _filter(bookingGroup.trips, (o) => {return o.tour_id === CYOA_NETWORK_IDS["europe"].id || o.tour_id === CYOA_NETWORK_IDS["usa"].id})[0];

    let _paid = 0;
    let _discount = 0;
    let _subtotal = 0;
    let _total = 0;
    let _accommodation = 0;

    if(HAS_CYO !== undefined && Object.keys(HAS_CYO).length > 0){

      if(itineraries !== undefined){

        const _itinerarySectors = (itineraries !== "") ? itineraries.sectors :  [];

        _paid = parseFloat(itineraries.total_paid);
        _discount = parseFloat(itineraries.discount);
        _subtotal = parseFloat(itineraries.total);
        _total = parseFloat(itineraries.grand_total);
        _accommodation = parseFloat(calculateAccommodationPrice(_itinerarySectors));

        this.setState({
          grandTotalPrice:_total.toFixed(2),
          grandTotal:_paid.toFixed(2),
          subtotal:_subtotal.toFixed(2),
          discount:_discount.toFixed(2),
          accommodation:_accommodation.toFixed(2)
        });

      }

    }else{

      const clientBookings = bookingGroup.trips;

      for(let i = 0; i < clientBookings.length; i++){
        for(let ii = 0; ii < clientBookings[i].passengers.length; ii++){
          _subtotal += clientBookings[i].passengers[ii].price;
          _total += clientBookings[i].passengers[ii].outstanding;
          _discount += clientBookings[i].passengers[ii].discount;
          _paid += clientBookings[i].passengers[ii].paid;
        }
      }

      this.setState({
        grandTotalPrice:_total.toFixed(2),
        grandTotal:_paid.toFixed(2),
        subtotal:_subtotal.toFixed(2),
        discount:_discount.toFixed(2)
      });

    }

  }

  render(){

    const { currency, bookingGroup, product, itineraries } = this.props;
    const { subtotal, discount, grandTotalPrice, grandTotal, accommodation } = this.state;
    const dueDate = (bookingGroup.trips) ? "Payable by " + calculateDueDate(bookingGroup.trips[0].departure_date,'45') : "";
    const showDueMessage = (grandTotalPrice === '0.00') ? false : true;


    if(Object.keys(bookingGroup).length === 0 || product.length === 0){
      return (<Spinner text="Loading Confirmation..." loadClass="loading-spinner center" />)
    }
    else{
      
      return(
        <React.Fragment>
        <div className="confirmation-payment-cyoa">
        <div className="row">
          <div className="columns small-12 large-11 large-offset-0-5">

            <div className="row">
              <div className="columns small-12 medium-10 large-9 medium-centered">
                <div className="columns small-12 medium-6">
                  <p className="payment-text orange-text bold">Payment Summary</p>
                </div>
                <div className="columns small-12 medium-6 text-center">
                  <a className="print-text orange-text" href={bookingGroup.documents[0].url} target="_blank">
                    Booking statement PDF
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 192V81.9c0-6.4-2.5-12.5-7-17L351 7c-4.5-4.5-10.6-7-17-7H120c-13.2 0-24 10.8-24 24v168c-53 0-96 43-96 96v136c0 13.2 10.8 24 24 24h72v40c0 13.2 10.8 24 24 24h272c13.2 0 24-10.8 24-24v-40h72c13.2 0 24-10.8 24-24V288c0-53-43-96-96-96zM128 32h202.8L384 85.2V256H128V32zm256 448H128v-96h256v96zm96-64h-64v-40c0-13.2-10.8-24-24-24H120c-13.2 0-24 10.8-24 24v40H32V288c0-35.3 28.7-64 64-64v40c0 13.2 10.8 24 24 24h272c13.2 0 24-10.8 24-24v-40c35.3 0 64 28.7 64 64v128zm-28-112c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20z"/></svg>
                  </a>
                  <a className="print-text orange-text" href={bookingGroup.documents[1].url} target="_blank">
                    Itinerary PDF
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 192V81.9c0-6.4-2.5-12.5-7-17L351 7c-4.5-4.5-10.6-7-17-7H120c-13.2 0-24 10.8-24 24v168c-53 0-96 43-96 96v136c0 13.2 10.8 24 24 24h72v40c0 13.2 10.8 24 24 24h272c13.2 0 24-10.8 24-24v-40h72c13.2 0 24-10.8 24-24V288c0-53-43-96-96-96zM128 32h202.8L384 85.2V256H128V32zm256 448H128v-96h256v96zm96-64h-64v-40c0-13.2-10.8-24-24-24H120c-13.2 0-24 10.8-24 24v40H32V288c0-35.3 28.7-64 64-64v40c0 13.2 10.8 24 24 24h272c13.2 0 24-10.8 24-24v-40c35.3 0 64 28.7 64 64v128zm-28-112c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20z"/></svg>
                  </a>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="columns small-12 medium-10 large-9 medium-centered">
                  <div className="payment-box margin-t-50">
                  <div className="row">
                    <div className="columns small-9">
                      <p className="bold no-margin">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" className="city-svg">
                          <path d="M172.3 501.7C27 291 0 269.4 0 192a192 192 0 1 1 384 0c0 77.4-27 99-172.3 309.7a24 24 0 0 1-39.4 0zM192 272a80 80 0 1 0 0-160 80 80 0 0 0 0 160z"/>
                        </svg>
                        Trips
                      </p>
                    </div>

                    <div className="columns small-3">
                      <p className="bold text-right no-margin">Price</p>
                    </div>
                  </div>
                  </div>

                  <hr />

                  {
                    _map(_sortBy(bookingGroup.trips, ['departure_date']), (item, i) => {return <TripDetailsCard key={i} data={item} index={i} currency={currency} product={product} itineraries={itineraries} />} )
                  }



                  <div className="payment-bar">
                    <div className="row">
                      <div className="columns small-6"><p className="no-margin bold">Subtotal</p></div>
                      <div className="columns small-6"><p className="no-margin bold text-right">{currency}{subtotal}</p></div>
                    </div>
                  </div>

                  <div className="payment-bar" style={{display: (discount === 0 || discount === "0.00") ? 'none' : 'block' }}>
                    <div className="row">
                      <div className="columns small-6"><p className="no-margin bold">Discount</p></div>
                      <div className="columns small-6"><p className="no-margin bold text-right">{currency}{discount}</p></div>
                    </div>
                  </div>

                  <div className="payment-bar">
                    <div className="row">
                      <div className="columns small-6"><p className="no-margin bold">Total paid</p></div>
                      <div className="columns small-6"><p className="no-margin bold text-right">{currency}{grandTotal}</p></div>
                    </div>
                  </div>


                  <div className="payment-bar no-border">
                    <div className="row">
                      <div className="columns small-6">
                        <p className="no-margin bold orange-text">
                        Total due
                        <br/>

                        <span className="due-text" style={{display: (grandTotal !== 0) ? "none" : "inline"}}>
                        (due within 14 days)
                        </span>

                        <span style={{display: (accommodation === "0.00" || accommodation === 0) ? "inline" : "none"}}>
                          <span className="due-text" style={{display:showDueMessage ? 'block' : 'none'}}>{dueDate}</span>
                        </span>

                        </p>
                      </div>
                      <div className="columns small-6"><p className="no-margin bold text-right orange-text">{currency}{grandTotalPrice}</p></div>
                    </div>
                    <div className="row">
                      <div className="columns small-12">
                        <span className="due-text" style={{display: (accommodation === "0.00" || accommodation === 0) ? 'none' : 'inline'}}>
                          Accommodation subject to availability to be confirmed via email.<sup>*</sup>
                        </span>
                      </div>
                      </div>
                  </div>




                  <div className="terms-text">
                    <div className="row">
                      <div className="columns small-12">
                        <p className="no-margin">Please make sure to check your itinerary and payment summary. </p>
                        <p className="no-margin"><a href="https://www.busabout.com/contact-us" target="_blank" rel="noopener noreferrer">Contact us</a> if you see any issues with your booking.</p>
                      </div>
                    </div>
                  </div>

                  <div className="button-share margin-t-40">
                    <div className="row">
                    <div className="columns small-12 text-center">
                    <a href="https://www.facebook.com/groups/busaboutcommunity" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="75.3154" height="67.5576" viewBox="0 0 75.3154 67.5576"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M31.07,57.4258H2.0722A2,2,0,0,1,.1171,55.8486c-.5781-2.6719,1.0205-6.9326,3.9785-10.6,2.9014-3.5977,9.582-9.6318,21.7207-9.6318a31.3626,31.3626,0,0,1,9.6357,1.4473,2,2,0,0,1-1.2285,3.8066,27.3616,27.3616,0,0,0-8.4072-1.2539c-10.4746,0-16.1543,5.1016-18.6074,8.1426a15.5564,15.5564,0,0,0-3.0264,5.666H31.07a2,2,0,0,1,0,4Z"/>
                      <path d="M47.0188,47.9045" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4"/>
                      <path d="M25.8164,39.6172a19.8086,19.8086,0,1,1,18.665-26.4551,2,2,0,0,1-3.7676,1.3418A15.8108,15.8108,0,1,0,25.8164,35.6172a15.67,15.67,0,0,0,6.7383-1.5029,2,2,0,0,1,1.707,3.6172A19.6367,19.6367,0,0,1,25.8164,39.6172Z"/>
                      <path d="M61.666,67.5576H26.44A2,2,0,0,1,24.4853,65.98c-.5781-2.6719,1.0205-6.9316,3.9785-10.6,2.9023-3.5967,9.582-9.6318,21.7217-9.6318,10.3828,0,16.7754,4.3691,20.3105,8.0342a2,2,0,0,1-2.8789,2.7773C64.62,53.4531,59.163,49.749,50.1855,49.749c-10.4756,0-16.1553,5.1025-18.6084,8.1436a15.5462,15.5462,0,0,0-3.0264,5.665H61.666a2,2,0,0,1,0,4Z"/>
                      <path d="M50.1855,49.749A19.8086,19.8086,0,1,1,69.9931,29.94,19.8306,19.8306,0,0,1,50.1855,49.749Zm0-35.6172A15.8086,15.8086,0,1,0,65.9931,29.94,15.8266,15.8266,0,0,0,50.1855,14.1318Z"/>
                      <path d="M50.0839,41.7227a10.1192,10.1192,0,0,1-9.5947-6.9336,2,2,0,1,1,3.793-1.27,6.1072,6.1072,0,0,0,11.7549-.5361,2,2,0,1,1,3.8945.91A10.2078,10.2078,0,0,1,50.0839,41.7227Z"/>
                      <path d="M73.3154,67.5576H67.9931a2,2,0,1,1,0-4h3.3223V60.18a2,2,0,0,1,4,0v5.3779A2,2,0,0,1,73.3154,67.5576Z"/>
                      <path d="M25.2011,31.5908a10.1157,10.1157,0,0,1-9.5937-6.9355A2,2,0,0,1,19.4,23.3877a6.1236,6.1236,0,0,0,5.8008,4.2031,6.5822,6.5822,0,0,0,6.3848-4.4492,2,2,0,1,1,3.8652,1.0293A10.5415,10.5415,0,0,1,25.2011,31.5908Z"/>
                      <path d="M31.07,57.4258H2.0722A2,2,0,0,1,.1171,55.8486c-.5781-2.6719,1.0205-6.9326,3.9785-10.6,2.9014-3.5977,9.582-9.6318,21.7207-9.6318a31.3626,31.3626,0,0,1,9.6357,1.4473,2,2,0,0,1-1.2285,3.8066,27.3616,27.3616,0,0,0-8.4072-1.2539c-10.4746,0-16.1543,5.1016-18.6074,8.1426a15.5564,15.5564,0,0,0-3.0264,5.666H31.07a2,2,0,0,1,0,4Z"/>
                      <path d="M47.0188,47.9045" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4"/>
                      <path d="M25.8164,39.6172a19.8086,19.8086,0,1,1,18.665-26.4551,2,2,0,0,1-3.7676,1.3418A15.8108,15.8108,0,1,0,25.8164,35.6172a15.67,15.67,0,0,0,6.7383-1.5029,2,2,0,0,1,1.707,3.6172A19.6367,19.6367,0,0,1,25.8164,39.6172Z"/>
                      <path d="M61.666,67.5576H26.44A2,2,0,0,1,24.4853,65.98c-.5781-2.6719,1.0205-6.9316,3.9785-10.6,2.9023-3.5967,9.582-9.6318,21.7217-9.6318,10.3828,0,16.7754,4.3691,20.3105,8.0342a2,2,0,0,1-2.8789,2.7773C64.62,53.4531,59.163,49.749,50.1855,49.749c-10.4756,0-16.1553,5.1025-18.6084,8.1436a15.5462,15.5462,0,0,0-3.0264,5.665H61.666a2,2,0,0,1,0,4Z"/>
                      <path d="M50.1855,49.749A19.8086,19.8086,0,1,1,69.9931,29.94,19.8306,19.8306,0,0,1,50.1855,49.749Zm0-35.6172A15.8086,15.8086,0,1,0,65.9931,29.94,15.8266,15.8266,0,0,0,50.1855,14.1318Z"/>
                      <path d="M50.0839,41.7227a10.1192,10.1192,0,0,1-9.5947-6.9336,2,2,0,1,1,3.793-1.27,6.1072,6.1072,0,0,0,11.7549-.5361,2,2,0,1,1,3.8945.91A10.2078,10.2078,0,0,1,50.0839,41.7227Z"/>
                      <path d="M73.3154,67.5576H67.9931a2,2,0,1,1,0-4h3.3223V60.18a2,2,0,0,1,4,0v5.3779A2,2,0,0,1,73.3154,67.5576Z"/>
                      <path d="M25.2011,31.5908a10.1157,10.1157,0,0,1-9.5937-6.9355A2,2,0,0,1,19.4,23.3877a6.1236,6.1236,0,0,0,5.8008,4.2031,6.5822,6.5822,0,0,0,6.3848-4.4492,2,2,0,1,1,3.8652,1.0293A10.5415,10.5415,0,0,1,25.2011,31.5908Z"/></g></g></svg>
                      Join Busabout Community on Facebook
                    </a>
                    </div>
                  </div>
                  </div>
              </div>
            </div>

          </div>
        </div>
        </div>
        <Footer />
        </React.Fragment>
      )
    }



  }

}

export default ConfirmationPaymentCyoa;



// WEBPACK FOOTER //
// ./src/components/confirmation/confirmationpaymentcyoa.js